// tslint:disable
export var PlanType;
(function (PlanType) {
    // HMHEALTH
    PlanType[PlanType["HMHEALTH"] = 19] = "HMHEALTH";
    // AUTOINJ
    PlanType[PlanType["AUTOINJ"] = 21] = "AUTOINJ";
    // COMMPL
    PlanType[PlanType["COMMPL"] = 22] = "COMMPL";
    // FEDPL
    PlanType[PlanType["FEDPL"] = 23] = "FEDPL";
    // MEDAD
    PlanType[PlanType["MEDAD"] = 24] = "MEDAD";
    // MDCRAD
    PlanType[PlanType["MDCRAD"] = 25] = "MDCRAD";
    // MDCRB
    PlanType[PlanType["MDCRB"] = 26] = "MDCRB";
    // MDCRD
    PlanType[PlanType["MDCRD"] = 27] = "MDCRD";
    // MDGP
    PlanType[PlanType["MDGP"] = 28] = "MDGP";
    // VATC
    PlanType[PlanType["VATC"] = 29] = "VATC";
    // WRKCMP
    PlanType[PlanType["WRKCMP"] = 30] = "WRKCMP";
    // PLAN
    PlanType[PlanType["PLAN"] = 31] = "PLAN";
    // DMEP
    PlanType[PlanType["DMEP"] = 33] = "DMEP";
    // MCMP
    PlanType[PlanType["MCMP"] = 34] = "MCMP";
    // SPAP
    PlanType[PlanType["SPAP"] = 35] = "SPAP";
    // MEDAB
    PlanType[PlanType["MEDAB"] = 36] = "MEDAB";
    // ADAP
    PlanType[PlanType["ADAP"] = 37] = "ADAP";
    // STPL
    PlanType[PlanType["STPL"] = 38] = "STPL";
    // EPO
    PlanType[PlanType["EPO"] = 40] = "EPO";
    // INDEM
    PlanType[PlanType["INDEM"] = 41] = "INDEM";
    // HMO
    PlanType[PlanType["HMO"] = 42] = "HMO";
    // POSP
    PlanType[PlanType["POSP"] = 43] = "POSP";
    // PPO
    PlanType[PlanType["PPO"] = 44] = "PPO";
    // MDCRA
    PlanType[PlanType["MDCRA"] = 48] = "MDCRA";
    // SecSupp
    PlanType[PlanType["SecSupp"] = 54] = "SecSupp";
    // Employee
    PlanType[PlanType["Employee"] = 63] = "Employee";
})(PlanType || (PlanType = {}));
PlanType['SECSUPP'] = 54;
PlanType['EMPLOYEE'] = 63;
//# sourceMappingURL=PlanType.js.map